export const getTextFilterCounterText = (count: number) =>
  `${count} ${count === 1 ? 'match' : 'matches'}`;
